/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import { registryCombineReducer } from 'mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/combineRegistry';

import TasksExecDisputeForm from './TasksExecDisputeForm';
import TasksExecMessageForm from './TasksExecMessageForm';
import TasksExecRemakeForm from './TasksExecRemakeForm';
import TasksExecConfirmForm from './TasksExecConfirmForm';
import TaskExecCancelByTaskOwnerFrom from './TaskExecCancelByTaskOwnerFrom';

const tabConfirm = 'tabConfirm';
const tabRemake = 'tabRemake';
const tabMessage = 'tabMessage';
const tabDispute = 'tabDispute';
const tabCancelByCustomer = 'tabCancelByCustomer';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecsFormsBlockAsOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActive: null,
      formReduceName: `taskExecOwnerForms-${props.exec.id}`
    };
    registryCombineReducer(this.state.formReduceName);
  }

  closeAllTabs = () => {
    this.setState({ tabActive: null });
  };

  hasTabConfirmDisabled = () => ![2, 3].includes(this.props.exec.status);
  hasTabRemakeDisabled = () => ![2].includes(this.props.exec.status);
  hasTabMessageDisabled = () => false;
  hasTabDisputeDisabled = () => ![2, 3].includes(this.props.exec.status);
  hasTabCancelByCustomerDisabledDescDisabled = () =>
    !this.props.exec.abilityToCancel ||
    ![2, 3].includes(this.props.exec.status);

  handleChangeTab = (e, name) => {
    e.preventDefault();
    if (
      (name === tabConfirm && !this.hasTabConfirmDisabled()) ||
      (name === tabRemake && !this.hasTabRemakeDisabled()) ||
      (name === tabMessage && !this.hasTabMessageDisabled()) ||
      (name === tabDispute && !this.hasTabDisputeDisabled()) ||
      (name === tabCancelByCustomer &&
        !this.hasTabCancelByCustomerDisabledDescDisabled())
    ) {
      if (name === this.state.tabActive) {
        this.setState({ tabActive: null });
      } else {
        this.setState({ tabActive: name });
      }
    }
  };

  render() {
    if ([4, 5, 6, 8].includes(this.props.exec.status)) {
      return null;
    }

    const tabConfirmDisabledDesc = this.hasTabConfirmDisabled()
      ? t('Нельзя подтвердить в текущем состоянии выполнения')
      : null;
    const tabRemakeDisabledDesc = this.hasTabRemakeDisabled()
      ? t('Нельзя отправить на доработку в текущем состоянии выполнения')
      : null;
    const tabMessageDisabledDesc = '';
    const tabDisputeDisabledDesc = this.hasTabDisputeDisabled()
      ? t('Нельзя обратиться в арбитраж в текущем состоянии выполнения')
      : null;

    let tabCancelByCustomerDisabledDesc = null;
    if (this.hasTabCancelByCustomerDisabledDescDisabled) {
      if (
        this.props.exec.abilityToCancel &&
        ![2, 3].includes(this.props.exec.status)
      ) {
        tabCancelByCustomerDisabledDesc = t(
          'Вы сможете отклонить выполнение после первого отчета от исполнителя'
        );
      } else if (!this.props.exec.abilityToCancel) {
        tabCancelByCustomerDisabledDesc = t('Нельзя отклонить это выполнение');
      }
    }

    const tabActiveClass = tabActive => {
      switch (this.state.tabActive) {
        case tabActive:
          return 'active';
        default:
          return '';
      }
    };
    const tabContent = () => {
      switch (this.state.tabActive) {
        case tabConfirm:
          return (
            <TasksExecConfirmForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        case tabRemake:
          return (
            <TasksExecRemakeForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        case tabMessage:
          return (
            <TasksExecMessageForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        case tabDispute:
          return (
            <TasksExecDisputeForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        case tabCancelByCustomer:
          return (
            <TaskExecCancelByTaskOwnerFrom
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        default:
          return null;
      }
    };
    return (
      <div data-toggle="tab-close-click-out" className="active">
        <div className="panel-bar bg-main">
          <ul className="nav nav-tabs nav-tabs-lg">
            <li
              className={`pull-right ${tabActiveClass(tabConfirm)}${
                this.hasTabConfirmDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title=""
              data-original-title={tabConfirmDisabledDesc}
            >
              <a
                href=""
                className="text-success"
                onClick={e => {
                  this.handleChangeTab(e, tabConfirm);
                }}
              >
                <i className="fa fa-check-circle" /> {t('Принять')}
              </a>
            </li>
            <li
              className={`pull-right ${tabActiveClass(tabRemake)}${
                this.hasTabRemakeDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title=""
              data-original-title={tabRemakeDisabledDesc}
            >
              <a
                href=""
                className="text-danger"
                onClick={e => {
                  this.handleChangeTab(e, tabRemake);
                }}
              >
                <i className="fa fa-undo" /> {t('На доработку')}
              </a>
            </li>
            <li
              className={`pull-right ${tabActiveClass(tabCancelByCustomer)}${
                this.hasTabCancelByCustomerDisabledDescDisabled()
                  ? ' disabled'
                  : ''
              }`}
              data-toggle="tooltip"
              title=""
              data-original-title={tabCancelByCustomerDisabledDesc}
            >
              <a
                href=""
                className="text-danger"
                onClick={e => {
                  this.handleChangeTab(e, tabCancelByCustomer);
                }}
              >
                <i className="fa fa-ban" /> {t('Отклонить')}
              </a>
            </li>
            <li
              className={`pull-right ${tabActiveClass(tabMessage)}${
                this.hasTabMessageDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title={tabMessageDisabledDesc}
              data-original-title={tabMessageDisabledDesc}
            >
              <a
                className="text-muted"
                data-toggle="tab"
                href=""
                aria-expanded="true"
                onClick={e => {
                  this.handleChangeTab(e, tabMessage);
                }}
              >
                <i className="fa fa-comment" /> {t('Сообщение')}
              </a>
            </li>
            <li
              className={`pull-left ${tabActiveClass(tabDispute)}${
                this.hasTabDisputeDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title={tabDisputeDisabledDesc}
              data-original-title={tabDisputeDisabledDesc}
            >
              <a
                className="text-muted"
                data-toggle="tab"
                href=""
                aria-expanded="true"
                onClick={e => {
                  this.handleChangeTab(e, tabDispute);
                }}
              >
                <span className="text-warning">
                  <i className="fa fa-gavel" />
                </span>{' '}
                {t('Арбитраж')}
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">{tabContent()}</div>
      </div>
    );
  }
}

TasksExecsFormsBlockAsOwner.propTypes = {
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    statusName: PropTypes.string.isRequired,
    abilityToCancel: PropTypes.number.isRequired
  }).isRequired
};

export default withRouter(TasksExecsFormsBlockAsOwner);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecsFormsBlockAsOwner.js